var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessCenterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#1f1f1f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.28-177q-24.22 0-40.75-16.53T137-234.5v-376q0-24.44 16.53-40.97Q170.06-668 194.5-668H375v-45.54q0-24.46 16.53-40.96t40.76-16.5h95.42q24.23 0 40.76 16.53Q585-737.94 585-713.5v45.5h180.5q24.44 0 40.97 16.53Q823-634.94 823-610.5v376q0 24.44-16.53 40.97Q789.94-177 765.72-177H194.28ZM400.5-668h159v-45.5q0-12-10-22t-22-10h-95q-12 0-22 10t-10 22v45.5Zm397 280.5h-252v52.5H415v-52.5H162.5v153q0 12 10 22t22 10h571q12 0 22-10t10-22v-153Zm-357 27H520V-440h-79.5v79.5Zm-278-52.5H415v-52.5h130.5v52.5h252v-197.5q0-12-10-22t-22-10h-571q-12 0-22 10t-10 22V-413ZM480-400.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessCenterIcon);
export default __webpack_public_path__ + "static/media/BusinessCenterIcon.c34f721a5a40fdcfa60ac2d9ebd8e520.svg";
export { ForwardRef as ReactComponent };